<template>
  <v-dialog persistent v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="headline">Import site config mapping</v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-skeleton-loader
            tile
            class="migration-skeleton"
            max-width="320"
            type="text, text, list-item, list-item, list-item"
            v-if="loading"
          />
          <v-radio-group v-model="selectedSite" v-else>
            <template v-slot:label>
              <p class="mb-0">
                We can not recognize a
                <strong>business</strong>
                for this session, please select the correct one:
              </p>
              <p class="caption text-center mt-1 mb-0" v-if="!sites.length">
                Business mapping not found
              </p>
            </template>
            <template v-for="site in sites">
              <v-tooltip
                bottom
                color="white"
                :key="site.site"
                v-if="!site.available"
              >
                <template v-slot:activator="{ on }">
                  <v-badge
                    bordered
                    left
                    overlap
                    color="warning"
                    icon="mdi-lock"
                  >
                    <v-radio :value="site.site" v-on="on">
                      <template v-slot:label>
                        <div>{{ site.name }}</div>
                      </template>
                    </v-radio>
                  </v-badge>
                </template>
                <span class="black--text">
                  <strong>Warning:</strong>
                  this business has been already selected.
                </span>
              </v-tooltip>
              <v-radio :value="site.site" :key="site.site" v-else>
                <template v-slot:label>
                  <div>{{ site.name }}</div>
                </template>
              </v-radio>
            </template>
          </v-radio-group>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          :loading="loading || updating"
          @click="handleComplete"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { businessApiV1 } from '@/api/v1';
import { businessApiV2 } from '@/api/v2';
import _ from 'lodash';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      updating: false,
      sessionId: null,
      environment: null,
      sites: [],
      selectedSite: null
    };
  },
  methods: {
    open(environment, sessionId) {
      this.dialog = true;
      this.environment = environment;
      this.sessionId = sessionId;
      this.getSites();
    },
    handleClose() {
      this.dialog = false;
      this.loading = false;
      this.updating = false;
      this.sites = [];
    },
    async handleComplete() {
      this.updating = true;
      await (
        this.$store.getters.isMatcherApiV2Enabled
          ? businessApiV2
          : businessApiV1
      ).updateSessionSite(this.environment, this.sessionId, this.selectedSite);
      this.handleClose();
    },
    async getSites() {
      this.loading = true;
      this.sites = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? businessApiV2
          : businessApiV1
      ).fetchSessionSites(this.environment, this.sessionId);
      this.selectedSite = _.get(_.head(this.sites), 'site');
      this.loading = false;
    }
  }
};
</script>
